

export const useCanvasDrawStyles = () => {

  return {
    sketchCanvas: {
      zIndex: 0
    },
  }
}